import { forwardRef } from 'react'

import { TooltipRenderProps } from 'react-joyride'

import clsx from 'clsx'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { StepWithArrowOffset } from 'shared/ui/joyride-tour/types.ts'

import s from './styles.module.scss'

export const JoyrideTooltip = forwardRef<HTMLDivElement, TooltipRenderProps>(
  (props, ref) => {
    const { index, size, step, tooltipProps, primaryProps } = props
    const stepIndex = index + 1
    const isLastStep = stepIndex === size

    const progress = (
      <div className={clsx(s.progress, 'medium-14')}>
        {stepIndex}/{size}
      </div>
    )

    const primaryButton = (
      <button
        className={s.button}
        {...primaryProps}
      >
        {primaryProps.title}
        {!isLastStep && (
          <AppIcon
            id={AllIcons.ARROW_RIGHT_LONG}
            width={20}
            height={20}
          />
        )}
      </button>
    )

    const placement = step.placement || 'bottom'
    const isBottom = placement.startsWith('bottom')
    const isTop = placement.startsWith('top')

    const arrowOffset = (step as StepWithArrowOffset).arrowOffset || 0

    return (
      <div
        {...tooltipProps}
        ref={ref}
        className={clsx(s.tooltip, {
          [s.tooltipBottom]: isBottom,
          [s.tooltipTop]: isTop,
        })}
      >
        <div
          className={clsx(s.arrow, {
            [s.arrowBottom]: isBottom,
            [s.arrowTop]: isTop,
          })}
          style={{
            transform: `translateX(${arrowOffset}px)`,
          }}
        />

        <div className={clsx(s.tooltipContent, 'medium-14')}>
          {step.content}
        </div>

        <div className={s.tooltipFooter}>
          <div className={s.tooltipActions}>{primaryButton}</div>
          {size !== 1 && progress}
        </div>
      </div>
    )
  },
)

JoyrideTooltip.displayName = 'JoyrideTooltip'
